<div *ngIf="servicedHousesList" class="serviced-houses-list-container">

  <div class="list-element" *ngIf="checkboxOn">

    <div>

      <lib-checkbox *ngIf="checkboxOn" (change)="setAllBuildingsChecked()" [checked]="allBuildingsChecked"></lib-checkbox>

      <span>ÐÑÐµ Ð´Ð¾Ð¼Ð°</span>

    </div>
  </div>

  <div
    *ngFor="let house of servicedHousesList.contents; trackBy: trackByFn;"
    class="list-element"
    [ngClass]="{'arrow' : !checkboxOn}"
    (click)="setActiveElement(house)"
  >
    <div *ngIf="chatsService.buildingId && house.title" style="color: #8a8a8a;">{{house.title + ':' || 'Ð¢Ð¸Ð¿ ÑÐ°ÑÐ°'}}</div>
    <div *ngIf="!chatsService.buildingId" style="color: #8a8a8a;">Ð§Ð°Ñ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð½Ð¸ÐºÐ¾Ð²{{house.address ? ':' : ''}}</div>
    <div *ngIf="!chatsService.buildingId && house.address">{{house.address}}</div>
    <div *ngIf="!chatsService.buildingId" style="color: #8a8a8a;">Ñ Ð£Ð:</div>
    <div>
      <lib-checkbox *ngIf="checkboxOn" (change)="checkBuilding(house.id)" [checked]="checkBuildings[house.id]">
      </lib-checkbox>
      <span *ngIf="house.address && !house.sc" class="address">{{house.address}}</span>
    </div>
    <div *ngIf="house.sc">{{house.sc || 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð£Ð'}}</div>
    <span *ngIf="house.cadaster" class="cadastral-number">{{house.cadaster}}</span>
  </div>
</div>
